import { render } from "./ProfileClient.vue?vue&type=template&id=26c06f2e"
import script from "./ProfileClient.vue?vue&type=script&lang=js"
export * from "./ProfileClient.vue?vue&type=script&lang=js"

import "./ProfileClient.vue?vue&type=style&index=0&id=26c06f2e&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__